import { atom } from "recoil"

export const reservedIdState = atom<string | undefined>({
  key: "atoms/contact/create/reservedIdState",
  default: undefined,
})
